module.exports = __webpack_public_path__ + "img/colorful.7bd5b955.svg";